module.exports = __webpack_public_path__ + "img/84.ae4c7553.svg";